import { Injectable } from '@angular/core';
import { ApiService, Pagination, PER_PAGE } from './api.service';
import { User } from '@shared/entities/user';
import { Paginate } from '@shared/entities/paginate';
import { BehaviorSubject, Observable, shareReplay, Subject, switchMap } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';

export interface CompanyGroupUsersFilterURL {
  companyGroupId?: string;
  keyword?: string;
  accountId?: string;
  serialNumber?: string;
}

@Injectable({
  providedIn: 'root'
})
export class CompanyGroupUsersService extends ApiService<User> {
  private _refresh$: Subject<Pagination>;
  allUsers$: Observable<Paginate<User>>;
  private _currentPaginator: Pagination;
  private _currentFilters: CompanyGroupUsersFilterURL = {};

  set filters(value: CompanyGroupUsersFilterURL) {
    this._currentFilters = value;
    this.refresh(1);
  }

  constructor(private http: HttpClient) {
    super(User, '/users', '/users');
    this._currentPaginator = { page: 1, perPage: PER_PAGE };
    this._refresh$ = new BehaviorSubject<Pagination>(this._currentPaginator);
    this.allUsers$ = this._refresh$.pipe(
      switchMap((pagination) => {
        if (this._currentFilters.companyGroupId) {
          this.setUrlParameter('companyGroupId', this._currentFilters.companyGroupId);
        } else {
          this.removeUrlParameter('companyGroupId');
        }
        if (this._currentFilters.keyword) {
          this.setUrlParameter('keyword', this._currentFilters.keyword);
        } else {
          this.removeUrlParameter('keyword');
        }
        if (this._currentFilters.accountId) {
          this.setUrlParameter('accountId', this._currentFilters.accountId);
        } else {
          this.removeUrlParameter('accountId');
        }
        if (this._currentFilters.serialNumber) {
          this.setUrlParameter('serialNumber', this._currentFilters.serialNumber);
        } else {
          this.removeUrlParameter('serialNumber');
        }
        return this.paginate(User, pagination.page, pagination.perPage);
      }),
      shareReplay(1)
    );
  }

  refresh(page: number, perPage: number = PER_PAGE) {
    this._currentPaginator = { page, perPage };
    this._refresh$.next(this._currentPaginator);
  }

  switchUser(targetUserId: string) {
    return this.http.post<{ customToken: string; originalUserEmail: string }>(
      `${environment.apiBaseUrl}/auth/switch-user`,
      { targetUserId }
    );
  }

  resetUser(originalUserEmail: string) {
    return this.http.post<{ customToken: string }>(
      `${environment.apiBaseUrl}/auth/switch-user/reset`,
      { originalUserEmail }
    );
  }
}
